/* eslint-disable max-len */
import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const TabletIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.7022 14.1659"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { title ? <title>{ title }</title> : null }

      <g>
        <rect height="14.1659" opacity="0" width="18.7022" x="0" y="0"/>
        <path d="M2.32102 13.1987C1.44047 13.1987 0.96719 12.7362 0.96719 11.8341L0.96719 2.35227C0.96719 1.45016 1.44047 0.987659 2.32102 0.987659L15.9749 0.987659C16.838 0.987659 17.3287 1.45016 17.3287 2.35227L17.3287 11.8341C17.3287 12.7362 16.838 13.1987 15.9749 13.1987Z" fill={ color } fillOpacity="0.2125"/>
        <path d="M2.30297 14.1659L15.9905 14.1659C17.5222 14.1659 18.2959 13.3849 18.2959 11.8821L18.2959 2.3043C18.2959 0.801485 17.5222 0.0204687 15.9905 0.0204687L2.30297 0.0204687C0.779141 0.0204687 0 0.788828 0 2.3043L0 11.8821C0 13.3976 0.779141 14.1659 2.30297 14.1659ZM2.32102 13.1987C1.44047 13.1987 0.96719 12.7362 0.96719 11.8341L0.96719 2.35227C0.96719 1.45016 1.44047 0.987659 2.32102 0.987659L15.9749 0.987659C16.838 0.987659 17.3287 1.45016 17.3287 2.35227L17.3287 11.8341C17.3287 12.7362 16.838 13.1987 15.9749 13.1987ZM5.93617 12.5996L12.3627 12.5996C12.5398 12.5996 12.6688 12.4759 12.6688 12.2935C12.6688 12.1111 12.5398 11.9845 12.3627 11.9845L5.93617 11.9845C5.76156 11.9845 5.62711 12.1111 5.62711 12.2935C5.62711 12.4759 5.76156 12.5996 5.93617 12.5996Z" fill={ color } />
      </g>
    </svg>
  );
});
